import {Box, Typography} from "@mui/material";
import {fontType} from "../../constants/font";
import React from "react";

function SuccessStoryCitation({
    citation,
    person,
    role
}) {
    return (
        <Box
        >
            <Typography
                sx={{
                    color: "#1b144a",
                    fontFamily: fontType.semiBold,
                    fontSize: "18px",
                    lineHeight: "22px",
                    marginBottom: "30px",
                    paddingRight: { md: "0", xs: "15px" },
                    paddingLeft: { md: "0", xs: "15px" },
                    textAlign: { md: "center", xs: "center" },
                }}
            >
                { citation }
            </Typography>
            <Typography
                sx={{
                    color: "#1b144a",
                    fontFamily: fontType.regular,
                    fontSize: "18px",
                    lineHeight: "22px",
                    marginBottom: "10px",
                    paddingRight: { md: "0", xs: "15px" },
                    paddingLeft: { md: "0", xs: "15px" },
                    textAlign: { md: "center", xs: "center" },
                }}
            >
                { person }
            </Typography>
            <Typography
                sx={{
                    color: "#1b144a",
                    fontFamily: fontType.italic,
                    fontSize: "18px",
                    lineHeight: "22px",
                    paddingRight: { md: "0", xs: "15px" },
                    paddingLeft: { md: "0", xs: "15px" },
                    textAlign: { md: "center", xs: "center" },
                }}
            >
                { role }
            </Typography>
        </Box>
    )
}

export default SuccessStoryCitation;